// Privacy-safe analytics hooks. Events only — never financial inputs (income, debts,
// housing, credit score, vehicle price) or any PII.
const SAFE_EVENTS = new Set([
  "calculator_started",
  "calculator_completed",
  "fit_started",
  "fit_completed",
  "app_cta_clicked",
  "handoff_created",
  "loan_cta_clicked",
  "refinance_cta_clicked",
]);

export function track(event, props = {}) {
  if (!SAFE_EVENTS.has(event)) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...props });
  } catch {
    /* no-op */
  }
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[analytics]", event, props);
  }
}
